<div class="ab-list-item-inner flex w-100 activity-type--canvass-attempt">
  <span class="ab-list-item__icon">
    <!--
        using svg for now. this icon is from FontAwesome v6;
        we *should* migrate to v6 at some point, but that will
        require some work since classnames have changed in v6
        - Jarrod (2022-04-20)
        -->
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 640 512">
      <path d="M208 224C196.1 224 188 232.1 188 244c0 11.04 8.955 20 20 20s20-8.955 20-20C228 232.1 219
                   224 208 224zM224.6 80H188.2C163.8 80 144 99.84 144 124.2c0 8.844 7.156 16 16 16s16-7.156
                   16-16C176 117.5 181.5 112 188.2 112h36.36C233.1 112 240 118.9 240 127.4c0 5.875-3.266
                   11.16-8.734 13.89L200.6 157.2C195.3 159.1 192 165.4 192 171.4V192c0 8.844 7.156 16 16
                   16S224 200.8 224 192V181.1l21.78-11.31C261.1 161.8 272 145.5 272 127.4C272 101.3 250.7
                   80 224.6 80zM416 176C416 78.8 322.9 0 208 0S0 78.8 0 176c0 41.48 17.07 79.54 45.44
                   109.6c-15.17 32.34-38.65 58.07-38.95 58.38c-6.514 6.836-8.309 16.91-4.568 25.67C5.754
                   378.4 14.26 384 23.66 384c54.19 0 97.76-20.73 125.9-39.17C168.1 349.4 187.7 352 208
                   352C322.9 352 416 273.2 416 176zM208 320c-16.96 0-34.04-2.098-50.75-6.232L143.7
                   310.4L132 318.1c-20.43 13.38-51.58 28.99-89.85 32.97c9.377-12.11 22.3-30.63
                   32.24-51.82l9.242-19.71L68.72 263.7C44.7 238.2 32 207.9 32 176C32 96.6 110.1 32 208
                   32S384 96.6 384 176S305 320 208 320zM606.4 435.4C627.6 407.1 640 372.9 640 336C640
                   238.8 554 160 448 160c-.3145 0-.6191 .041-.9336 .043C447.5 165.3 448 170.6 448 176c0
                   5.43-.4668 10.76-.9414 16.09C447.4 192.1 447.7 192 448 192c88.22 0 160 64.6 160 144c0
                   28.69-9.424 56.45-27.25 80.26l-13.08 17.47l11.49 18.55c6.568 10.61 13.18 19.74 18.61
                   26.74c-18.26-1.91-36.45-6.625-54.3-14.09l-12.69-5.305l-12.58 5.557C495.9 475 472.3 480 448
                   480c-75.05 0-137.7-46.91-154.9-109.7c-10.1 3.336-20.5 6.132-31.2 8.271C282.7 455.1 357.1
                   512 448 512c29.82 0 57.94-6.414 83.12-17.54C555 504.5 583.7 512 616.3 512c9.398 0 17.91-5.57
                   21.73-14.32c3.74-8.758 1.945-18.84-4.568-25.67C633.3 471.8 619.6 456.8 606.4 435.4z" />
    </svg>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span> {{canvassResult()}}
      <app-activity-target-link [target]="item.target">{{item?.target | fullName}}</app-activity-target-link>
    </div>
    <div class="details">
      <div>Task: {{item.payload.action.name}}</div>
      <ng-container *ngIf="!isInPerson">
        <span class="tag"
              *ngIf="isPhone()">Phone</span>
        <span class="tag"
              *ngIf="!isPhone()">Address</span>

        <span class="tag-type meta ml-0025"
              *ngIf="isPhone()">
          ({{getHomeWorkMobile()}})
        </span>:

        <strong class="response">
          <span *ngIf="!isPhone()">{{item.payload?.address | address}}</span>
          <span *ngIf="isPhone()">{{item.payload?.phoneNumber?.number | phone}}</span>
        </strong>

        <span class="response-status meta ml-0025"
              *ngIf="getStatus() === 'do_not_contact'">
          <i class="fas fa-ban color--red pair__verified"
             matTooltip="Do not contact"
             matTooltipPosition="above"></i>
        </span>
        <span class="response-status meta ml-0025"
              *ngIf="getStatus() === 'verified'">
          <i class="far fa-check pair__verified"
             matTooltip="Confirmed"
             matTooltipPosition="above"></i>
        </span>
        <span class="response-status meta ml-0025"
              *ngIf="getSubscribed()">
          <i class="far fa-bell-on pair__verified ml-0050"
             [matTooltip]="'Subscribed'"
             [matTooltipPosition]="'left'"></i>
        </span>
      </ng-container>
      <div>Result: {{canvassSubResult() | propercase}}</div>
    </div>
  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
